import auth from '../auth/index';

function URL() {
  return auth.getApi();
}

function header() {
  var h = auth.getAuthHeader();
  return {
    headers: {
      'x-access-token': h['x-access-token'],
      'Accept': h['Accept'],
      'content-type': h['content-type']
    }
  };
}

function jsonToQuery(params){
  var urlParams;
  var i = 0;
  for (var param in params) {
    var p = `${param}=${params[param]}`;
    if(i != 0){
      urlParams += '&' + p;
    } else {
      urlParams = p;
    }
    i++;
  }
  return urlParams;
}

export default {
  renderDocs(context, callback) {
    context.$http.get(URL() + '/docs', header())
     .then((res) => {
       callback(res.body);
     }).catch((res) => {
       callback({
          'action': 'fail',
          'msg': res.body.msg
       });
     });
  },
  
  
  
  //////////////////// BOOKINGS //////////////////////////
  getSchedules(context, callback) {
    context.$http.get(URL() + '/api/super/schedules', header()).then(res => {
      callback(res.body)
    }).catch(err => {
      callback(err)
    })
  },

  newBooking(context, data, callback) {
    context.$http.post(URL() + '/api/staff/booking', data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      console.log(res)
      callback(res.body);
    });
  },

  updateBooking(context, id, data, callback) {
    context.$http.put(URL() + '/api/staff/booking/' + id, data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback(res.body);
    });
  },

  deleteBooking(context, id, callback) {
    context.$http.delete(`${URL()}/api/staff/booking/${id}?deleteRecurring=${context.deleteRecurring}`, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  getBookings(context, clientId, from, to, callback) {
    if(typeof from == 'function' && !callback) {
      callback = from;
      from = null;
    }
    context.$http.get(`${URL()}/api/bookings/${clientId}${from && to ? `?from=${from}&to=${to}` : ''}`, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      console.log('res', res)
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  getOneBooking(context, bookingId, callback) {
    context.$http.get(URL() + '/api/staff/booking/' + bookingId, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  getSiteBookings(context, siteId, callback) {
    context.$http.get(URL() + '/api/bookings/site/' + siteId, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  ////////////////// TEMP BOOKINGS////////////////////////
  newTempBooking(context, data, callback) {
    context.$http.post(URL() + '/api/public/temp/booking', data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  deleteTempBooking(context, id, callback) {
    context.$http.delete(URL() + '/api/public/temp/booking/' + id, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },



  ///////////////////// USERS ////////////////////////////////
  getAllUsers(context, callback) {
    context.$http.get(URL() + '/api/super/users', header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  getAllUsersForClient(context, id, callback){
    context.$http.get(URL() + '/api/admin/users/' + id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },

  newUser(context, data, callback) {
    context.$http.post(URL() + '/api/admin/user', data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      console.log(res);
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  registerUser(context, data, callback) {
    context.$http.post(URL() + '/api/public/user', data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      console.log(res);
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  updateUser(context, data, user_id, callback) {
    context.$http.put(URL() + '/api/admin/user/' + user_id, data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  deleteUser(context, user_id, callback) {
    context.$http.delete(URL() + '/api/admin/user/' + user_id, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  userHasGeneratedPass(context, user_id, callback) {
    context.$http.get(URL() + '/api/users/generated/' + user_id, header()).then((res) => {
      console.log(res);
      callback(res.body);
    }).catch((res) => {
      console.log(res);
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  
  getUserContact(context, callback) {
    context.$http.get(URL() + '/api/users/contact', header()).then((res) => {    
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  updateUserContact(context, data, callback) {
    context.$http.put(URL() + '/api/users/contact', data, header()).then((response) => {
      callback(response.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },

  getUserByEmail(context, email, callback){
    context.$http.get(URL() + '/api/public/user/email/'+email, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },

  checkFPCode(context, code, callback){
    context.$http.get(URL() + '/api/public/user/fpCode/' + code, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },

  resetPassword(context, data, callback){
    context.$http.post(URL() + '/api/public/user/reset', data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },


  /////////////////////// TIMER ////////////////////////////
  getClosestBooking(context, field_id, callback) {
    context.$http.get(URL() + '/api/field/booking/' + field_id, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },
  
  getStandbyTime(context, field_id, callback) {
    context.$http.get(URL() + '/api/site/standby/' + field_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  
  /////////////////////// DEVICES (SUPERADMIN) ////////////////////////////
  getDeviceTypes(context, callback){
    context.$http.get(URL() + '/api/super/devices/types', header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },
  
  getDevices(context, callback){
    context.$http.get(URL() + '/api/super/devices', header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  getRelayDevices(context, callback){
    context.$http.get(URL() + '/api/super/devices/relays', header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  getInterfaceDevices(context, callback){
    context.$http.get(URL() + '/api/super/devices/interfaces', header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },
  
  getOneDevice(context, device_id, callback){
    context.$http.get(URL() + '/api/super/device/' + device_id, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res
      });
    });
  },
  
  newDevice(context, data, callback){
    context.$http.post(URL() + '/api/super/device', data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },
  
  updateDevice(context, data, device_id, callback){
    context.$http.put(URL() + '/api/super/device/' + device_id, data, header()).then((response) => {
      callback(response.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },
  
  deleteDevice(context, device_id, callback){
    context.$http.delete(URL() + '/api/super/device/' + device_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  getRelayFunctions(context, callback){
    context.$http.get(URL() + '/api/super/relays/types', header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },
  
  getDeviceRelays(context, device_id, callback){
    context.$http.get(URL() + '/api/super/devices/relays/' + device_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  getDeviceRelaysAdmin(context, device_id, callback){
    context.$http.get(URL() + '/api/super/relays/devices/' + device_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  getRelayData(context, scene_id, callback){
    context.$http.get(URL() + '/api/super/relays/scene/' + scene_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  

  ////////////////////// LIGHTS //////////////////////////
  getLights(context, callback){
    context.$http.get(URL() + '/api/staff/lights', header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body ? err.body.msg : err
      });
    });
  },

  getLightsAtFieldOrNull(context, field_id, callback){
    context.$http.get(URL() + '/api/staff/lights/field/null/'+ field_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body ? err.body.msg : err
      });
    });
  },

  getLightsAtField(context, field_id, callback){
    context.$http.get(URL() + '/api/staff/lights/field/' + field_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body ? err.body.msg : err
      });
    });
  },

  getLightFromMAC(context, mac, callback){
    context.$http.get(URL() + '/api/staff/light/mac/'+ mac, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body ? err.body.msg : err
      });
    });
  },

  getLight(context, id, callback){
    context.$http.get(URL() + '/api/staff/light/'+ id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body ? err.body.msg : err
      });
    });
  },

  newLight(context, data, callback){
    context.$http.post(URL() + '/api/super/lights', data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body ? err.body.msg : err
      });
    });
  },

  updateLight(context, id, data, callback){
    context.$http.put(URL() + '/api/super/light/'+ id, data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body ? err.body.msg : err
      });
    });
  },
  

  /////////////////////// FIELDS ////////////////////////////
  
  getField(context, field_id, callback){
    context.$http.get(URL() + '/api/field/' + field_id, header()).then((response) => {
      callback(response.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },

  getFields(context, site_id, callback){
    context.$http.get(URL() + '/api/fields/' + site_id, header()).then((response) => {
      callback(response.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  getAllFields(context, callback){
    context.$http.get(URL() + '/api/super/fields/all', header()).then((response) => {
      callback(response.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  

  getSiteFields(context, client_id, callback){
    context.$http.get(URL() + '/api/sites/fields/' + client_id, header()).then((res)=>{
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  getAllSitesFields(context, callback){
    context.$http.get(URL() + '/api/super/sites/fields/all', header()).then((response)=>{
      callback(response.body);
    }).catch((error) => {
      callback(error.body);
    });
  },

  newField(context, data, callback){
    context.$http.post(URL() + '/api/super/field', data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },
  
  updateField(context, data, field_id, callback){
    context.$http.put(URL() + '/api/super/field/' + field_id, data, header()).then((response) => {
      callback(response.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },
  
  deleteField(context, field_id, callback){
    context.$http.delete(URL() + '/api/super/field/' + field_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },

  getFieldsScenes(context, callback){
    context.$http.get(URL() + '/api/fields/on/scenes', header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },

  getFieldsRelays(context, field_id, callback) {
    context.$http.get(`${URL()}/api/super/field/${field_id}/relays/`, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },

  ///////////////////// SCENES /////////////////////

  getScenes(context, field_id, callback){
    context.$http.get(URL() + '/api/scenes/' + field_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  getSceneTypes(context, callback){
    context.$http.get(URL() + '/api/types/scenes/', header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  getScenesWithRelays(context, field_id, callback){
    context.$http.get(URL() + '/api/scenes/relays/' + field_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },

  getScenesFormatted(context, field_id, callback){
    context.$http.get(URL() + '/api/scenes/formatted/' + field_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },

  newScene(context, data, callback){
    context.$http.post(URL() + '/api/super/scene', data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  updateScene(context, data, scene_id, callback){
    context.$http.put(URL() + '/api/super/scene/' + scene_id, data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },

  deleteScene(context, scene_id, callback){
    context.$http.delete(URL() + '/api/super/scene/' + scene_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },

  getFieldFullScene(context, field_id, callback){
    context.$http.get(URL() + '/api/field/scene/full/' + field_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },

  getFieldsOnSiteFullScenes(context, site_id, callback){
    context.$http.get(URL() + '/api/fields/scenes/full/'+ site_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },

  getControlBoxGroups(context, url, callback) {
    context.$http.get(`${url}/api/v1/1/groups`).then((res) => {
      callback(res.body)
    }).catch(err => {
      callback({
        'action': 'fail',
        'msg': err
      })
    })
  },

  getControlBoxScenes(context, url, groupId, callback) {
    context.$http.get(`${url}/api/v1/1/groups/${groupId}/scenes`).then((res) => {
      callback(res.body)
    }).catch(err => {
      callback({
        'action': 'fail',
        'msg': err
      })
    })
  },

  /////////////////////// SITES ////////////////////////////
  
  getSites(context, client_id, callback){
    context.$http.get(URL() + '/api/sites/' + client_id, header()).then((res)=>{
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  getAllSites(context, callback){
    context.$http.get(URL() + '/api/super/sites/all', header()).then((res)=>{
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },

  getSiteFromId(context, siteId, callback) {
    context.$http.get(URL() + '/api/site/' + siteId, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  newSite(context, data, callback){
    context.$http.post(URL() + '/api/super/site', data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  updateSite(context, data, site_id, callback){
    context.$http.put(URL() + '/api/super/site/' + site_id, data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },

  deleteSite(context, site_id, callback){
    context.$http.delete(URL() + '/api/super/site/' + site_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },

  getFieldTypes(context, callback) {
    context.$http.get(URL() + '/api/public/fieldtypes', header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  getSitesOfType(context, type_id, callback) {
    context.$http.get(URL() + '/api/public/fieldtypes/' + type_id, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      console.log(res)
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  getAllScenesAtSite(context, site_id, callback) {  
    context.$http.get(URL() + '/api/public/site/scenes/' + site_id, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      console.log(res)
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  getBookingsOnDateAtSite(context, site_id, date, callback) {
    context.$http.get(`${URL()}/api/public/bookings/${site_id}/${date}`, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      console.log(res)
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },



  //////////////// CLIENTS /////////////////////
  getAllClients(context, callback) {
    context.$http.get(URL() + '/api/super/clients', header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  getClient(context, clientId, callback) {
    context.$http.get(URL() + '/api/client/' + clientId, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  newClient(context, data, callback) {
    context.$http.post(URL() + '/api/super/client', data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },
  
  updateClient(context, data, client_id, callback){
    context.$http.put(URL() + '/api/super/client/' + client_id, data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },

  deleteClient(context, client_id, callback){
    context.$http.delete(URL() + '/api/super/client/' + client_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },
  
  //////////////////////// LOGGING ////////////////////////
  getAllConsumption(context, callback){
     context.$http.get(URL() + '/api/super/consumption', header()).then((resp) => {
        callback(resp.body);
      }).catch((err) => {
        callback({
          'action': 'fail',
          'msg': err
        });
      });
  },
  
  getConsumption(context, client_id, callback){
    context.$http.get(URL() + '/api/consumption/' + client_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  getFilteredConsumption(context, client_id, data, callback){
    context.$http.post(URL() + '/api/consumption/' + client_id, data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  getAllFilteredConsumption(context, data, callback){
    context.$http.post(URL() + '/api/super/consumption', data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  getFieldUsage(context, params, callback){
    var profile = JSON.parse(auth.getProfile());
    var urlParams = jsonToQuery(params);

    context.$http.get(URL() + '/api/usage/field/' + profile.client_id + '?' + urlParams, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  getCurrentUsage(context, callback){
    var profile = JSON.parse(auth.getProfile());
    context.$http.get(URL() + '/api/usage/current/' + profile.client_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  getUsageCSV(context, params, callback){
    var urlParams = jsonToQuery(params);
    var profile = JSON.parse(auth.getProfile());
    context.$http.get(URL() + '/api/usage/download/' + profile.client_id + '?' + urlParams, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  getConsumptionCSV(context, params, callback){
    var urlParams = jsonToQuery(params);
    var profile = JSON.parse(auth.getProfile());
    context.$http.get(URL() + '/api/consumption/download/' + profile.client_id + '?' + urlParams, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },

  getFieldTime(context, field_id, from, callback){
    context.$http.get(URL() + `/api/times/field/${field_id}/${from}`, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  
  getFieldsTime(context, from, to, callback){
    context.$http.get(URL() + `/api/times/fields/${from}/${to}`, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },

  getClientConsumption(context, client_id, callback){
    context.$http.get(URL() + '/api/logs/consumption/client/' + client_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      console.log(err)
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },

    //////////////// CLUBS //////////////////

    getClub(context, club_id, callback) {
      context.$http.get(`${URL()}/api/clubs/${club_id}`, header()).then(res => {
        callback(res.body);
      }).catch(err => {
        console.log(err);
        callback({
          action: "fail",
          msg: err.body.msg
        });
      });
    },
  
    getClubs(context, callback) {
      context.$http.get(`${URL()}/api/clubs`, header()).then(res => {
        callback(res.body);
      }).catch(err => {
        console.log(err);
        callback({
          action: "fail",
          msg: err.body.msg
        });
      });
    },
  
    getAllClubs(context, callback) {
      var profile = JSON.parse(auth.getProfile());
      context.$http.get(`${URL()}/api/super/clubs`, header()).then(res => {
        callback(res.body);
      }).catch(err => {
        console.log(err);
        callback({
          action: "fail",
          msg: err.body.msg
        });
      });
    },
  
    newClub(context, data, callback) {
      context.$http.post(`${URL()}/api/clubs/`, data, header()).then(res => {
        callback(res.body);
      }).catch(err => {
        console.log(err);
        callback({
          action: "fail",
          msg: err.body.msg
        });
      });
    },

    updateClub(context, club_id, data, callback) {
      context.$http.put(`${URL()}/api/clubs/${club_id}`, data, header()).then(res => {
        callback(res.body);
      }).catch(err => {
        console.log(err);
        callback({
          action: "fail",
          msg: err.body.msg
        });
      });
    },

    deleteClub(context, club_id, callback) {
      console.log('req', typeof callback)
      context.$http.delete(`${URL()}/api/clubs/${club_id}`, header()).then(res => {
        callback(res.body);
      }).catch(err => {
        console.log(err);
        callback({
          action: "fail",
          msg: err.body.msg
        });
      });
    },

  //////////////// MAILJET ////////////////

  // getMailjet and postMailjet probably don't work properly
  getMailjet(context, data, callback){
    context.$http.get(URL() + '/api/admin/mailjet/get/' + data.resource, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  postMailjet(context, data, callback){
    var resource = data.resource;
    delete data.resource;      
    context.$http.post(URL() + '/api/admin/mailjet/post/' + resource, data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  sendEmail(context, data, callback) {
    context.$http.post(URL() + '/api/admin/mailjet/send', data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  sendFPEmail(context, data, callback){
    context.$http.post(URL() + '/api/public/user/email/fp', data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },


  ////////////// CARBONTRACK /////////////////
  getCTAuth(context, callback) {
    context.$http.get(URL() + '/api/admin/carbontrack', header()).then((res) => {    
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  getCTAccount(context, callback) {
    context.$http.get(URL() + '/api/admin/carbontrack/account', header()).then((res) => {    
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  //////////////// STRIPE /////////////

  getStripeCustomers(context, callback) {
    context.$http.get(URL() + '/api/stripe/customers', header()).then((res) => {    
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  getStripeCustomer(context, cus_id, callback) {
    context.$http.get(URL() + '/api/stripe/customers/' + cus_id, header()).then((res) => {    
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  getStripeCustomerFromUserId(context, user_id, callback) {
    context.$http.get(URL() + '/api/stripe/customers/user/' + user_id, header()).then((res) => {    
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  createStripeCustomer(context, data, callback) {
    context.$http.post(URL() + '/api/stripe/customers', data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  chargeCard(context, data, callback) {
    context.$http.post(URL() + '/api/stripe/charge', data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  chargeNewCard(context, data, callback) {
    context.$http.post(URL() + '/api/stripe/charge/new', data, header()).then((res) => {
      callback(res.body);
    }).catch((res) => {
      callback({
        'action': 'fail',
        'msg': res.body.msg
      });
    });
  },

  ///////////////////////// XBEE GATEWAY /////////////////

  getZigbeeLogs(context, ip, port, mac, callback){
    if(typeof port === "function" && !callback) {
      callback = port;
      port = 80;
      mac = 'broadcast'
    } else if(typeof mac === "function" && !callback) {
      callback = mac;
      mac = 'broadcast'
    }

    context.$http.get(`${URL()}/api/staff/zigbee/logs/${ip}?mac=${mac}&port=${port}`, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },

  getZigbeeStatus(context, ip, port, mac, callback){
    if(typeof port === "function" && !callback) {
      callback = port;
      port = 80;
      mac = 'broadcast'
    } else if(typeof mac === "function" && !callback) {
      callback = mac;
      mac = 'broadcast'
    }

    context.$http.get(`${URL()}/api/staff/zigbee/status/${ip}?mac=${mac}&port=${port}`, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body ? err.body.msg : err
      });
    });
  },

  getZigbeeNodes(context, ip, port, callback){
    if(typeof port === "function" && !callback) {
      callback = port;
      port = 80;
    }

    context.$http.get(`${URL()}/api/staff/zigbee/nodes/${ip}?port=${port}`, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body ? err.body.msg : err
      });
    });
  },

  getZigbeesAtSite(context, site_id, callback){
    context.$http.get(URL() + '/api/staff/zigbee/at/'+ site_id, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },

  flashLightForSeconds(context, data, callback){
    context.$http.post(URL() + '/api/staff/zigbee/flash', data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      });
    });
  },

  turnZigbeeOn(context, data, callback) {
    context.$http.post(URL() + '/api/staff/zigbee/on', data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      })
    })
  },

  turnZigbeeOff(context, data, callback) {
    context.$http.post(URL() + '/api/staff/zigbee/off', data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      })
    })
  },

  setZigbeeLevel(context, data, callback) {
    context.$http.post(URL() + '/api/staff/zigbee/set', data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg
      })
    })
  },

  /* Old way
  sendSCIcommand(context, data, callback){
    context.$http.post(URL() + '/api/staff/zigbee/sci', data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err
      });
    });
  },
  */


  ////////////// GLOBALS //////////////////
  getGlobals(context, callback){
    context.$http.get(URL() + '/api/globals', header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg || err
      });
    });
  },

  updateGlobals(context, data, callback){
    context.$http.put(URL() + '/api/super/globals', data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg || err
      });
    });
  },

  newGlobal(context, data, callback){
    context.$http.post(URL() + '/api/super/globals', data, header()).then((res) => {
      callback(res.body);
    }).catch((err) => {
      callback({
        'action': 'fail',
        'msg': err.body.msg || err
      });
    });
  },
}



// WEBPACK FOOTER //
// ./src/requests/index.js